import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { Auth } from 'aws-amplify';
import FormSpinner from '../../common/utility/FormSpinner';
import * as upgradeAccountActions from '../../../store/actions/upgrade-account-actions';
import { isEmpty } from '../../utils/obj-utils';
import RegisterFormBanner from '../one-club-register/RegisterFormBanner';
import GTMUserActions from '../../common/utility/GTMUserActions';
import {
    MembershipTypes,
    getDestructuredTextWithMultipleLinks,
    getMultilineText
} from '../../../../../general/js/utils';

function BallotSignInSuccessForm({
    actions,
    formData,
    loading,
}) {
    const [isOneClubMember, setIsOneClubMember] = useState(false);
    const [displayForm, setDisplayForm] = useState(false);

    const { formBanner } = formData;

    useEffect(() => {
        Auth.currentAuthenticatedUser().then((user) => {
            setIsOneClubMember(user.attributes['custom:Membership'].includes(MembershipTypes.OneClub));
            setDisplayForm(true);
        }).catch((err) => { console.log(err); });
    });

    return (
        <div className='form-popup' >
            {loading || !displayForm ? <FormSpinner>/</FormSpinner> : null}
            <RegisterFormBanner
                formBanner={formBanner}
            ></RegisterFormBanner>
            <section className='form-popup__content'>
                {displayForm ? <Fragment>
                    {isOneClubMember ? <OneClubMemberMessage formData={formData} /> :
                        <NonOneClubMemberMessage formData={formData} actions={actions} />}
                </Fragment> : null}
            </section>
        </div>
    );
}

function OneClubMemberMessage(props) {
    const { formData } = props;

    if (isEmpty(formData)) { return null; }

    const messageParagraphs = getMultilineText(formData.oneClubMessage);

    return (
        <MultiLineMessage show={true} messageParagraphs={messageParagraphs}></MultiLineMessage>
    );
}

function MultiLineMessage({ messageParagraphs, show }) {
    return (<div className='pop-up-message' style={{ display: show ? '' : 'none' }}>
        {
            messageParagraphs.map((message) => {
                return <Fragment key={_.uniqueId()}><p>{message}</p><br /></Fragment>;
            })
        }
    </div>);
}

function NonOneClubMemberMessage(props) {
    const { formData, actions } = props;

    const [hideSaveButton, setHideSaveButton] = useState(true);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const { oneClubTermsAndServices, nonOneClubMessage, nonOneClubSuccessfulMessage } = formData;

    const messageParagraphs = getMultilineText(nonOneClubMessage);

    const successMessageParagraphs = getMultilineText(nonOneClubSuccessfulMessage);

    const joinOneClub = (event) => {
        event.preventDefault();

        actions.joinOneClub(formData.callbackUrl).then(() => {
            GTMUserActions.trackJoinTheOneClubAction();
            setShowSuccessMessage(true);
        });
    };

    const onJoinOneClubCheckboxChange = (event) => {
        setHideSaveButton(!event.target.checked);
    };

    return (<Fragment>
        <MultiLineMessage show={!showSuccessMessage} messageParagraphs={messageParagraphs}></MultiLineMessage>
        <div
            className={'form-field auto-mt-xs joinOneClubCheck-field'} style={{ display: showSuccessMessage ? 'none' : '' }}>
            <h5 className='form-checkbox-panel__title'>
                {getDestructuredTextWithMultipleLinks(
                    oneClubTermsAndServices.policy.label,
                    oneClubTermsAndServices.policy.link.split(';')
                )}
            </h5>
            <label className="form-switch">
                <input
                    type='checkbox'
                    className='form-checkbox__checkbox visually-hidden'
                    name={'joinOneClubCheck'}
                    id={'joinOneClubCheck'}
                    defaultChecked={false}
                    onChange={onJoinOneClubCheckboxChange}
                /><i></i>{oneClubTermsAndServices.label}
            </label>
        </div>
        <div className='form__sign-in'
            style={{ display: hideSaveButton || showSuccessMessage ? 'none' : 'flex' }} >
            <button
                className='button button--primary auto-mt-md'
                type='submit'
                data-dc-form-sso-ref='submit-button'
                onClick={joinOneClub}
            >
                <span className='button-content button-content--icon'>
                    <span>{formData.joinButtonMessage}</span>
                    <svg
                        className='icon button__arrow-right'
                        width='14'
                        height='12'
                        focusable='false'
                    >
                        <use xlinkHref='#icon-arrow-right'></use>
                    </svg>
                </span>
            </button>
        </div>
        <MultiLineMessage show={showSuccessMessage} messageParagraphs={successMessageParagraphs}></MultiLineMessage>
    </Fragment >);
}

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            joinOneClub: bindActionCreators(upgradeAccountActions.joinOneClub, dispatch)
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BallotSignInSuccessForm);
